import React, { useEffect, useState } from "react";
import { BASE_URL } from "../api";

function TermsConditions() {
  const [termsData, setTermsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTermsConditions = async () => {
      try {
        const response = await fetch(BASE_URL+'auth/admin-terms-conditions');
        const result = await response.json();
        
        if (result.code && result.data) {
          setTermsData(result.data);
        } else {
          setError('No terms and conditions available at this time.');
        }
      } catch (err) {
        console.error('Error fetching terms and conditions:', err);
        setError('Failed to load terms and conditions. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchTermsConditions();
  }, []);

  if (loading) {
    return (
      <div 
        className="company-form-container mx-auto mt-16 px-4 md:px-8 py-10 shadow-xl rounded-2xl border border-gray-200"
        style={{
          maxWidth: "1200px",
          margin: "2rem auto",
          padding: "2rem 1.5rem",
          background: "#e8f3f9",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)"
        }}
      >
        <div className="text-center">
          <p>Loading terms and conditions...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div 
        className="company-form-container mx-auto mt-16 px-4 md:px-8 py-10 shadow-xl rounded-2xl border border-gray-200"
        style={{
          maxWidth: "1200px",
          margin: "2rem auto",
          padding: "2rem 1.5rem",
          background: "#e8f3f9",
          boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)"
        }}
      >
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-black mb-3">
            Terms and Conditions
          </h2>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="company-form-container mx-auto mt-16 px-4 md:px-8 py-10 shadow-xl rounded-2xl border border-gray-200"
      style={{
        maxWidth: "1200px",
        margin: "2rem auto",
        padding: "2rem 1.5rem",
        background: "#e8f3f9",
        boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)"
      }}
    >
      <div className="text-center mb-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-black mb-3">
          Terms and Conditions
        </h2>
        {termsData.version && (
          <p className="text-gray-600 text-sm md:text-base">
            Version: {termsData.version}
          </p>
        )}
      </div>

      <div className="terms-content">
        {termsData.pdf ? (
          <div className="text-center">
            <iframe
              src={termsData.pdf}
              style={{
                width: '100%',
                height: '600px',
                minHeight: '500px',
                border: '1px solid #ccc',
                borderRadius: '8px'
              }}
              title="Terms and Conditions PDF"
            />
            <div className="mt-4">
              <a
                href={termsData.pdf}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline font-medium"
              >
                Open PDF in new tab
              </a>
            </div>
          </div>
        ) : termsData.content ? (
          <div
            className="text-gray-700 leading-relaxed text-sm md:text-base"
            style={{ lineHeight: '1.8' }}
            dangerouslySetInnerHTML={{ __html: termsData.content }}
          />
        ) : (
          <p className="text-gray-600 text-center">
            No terms and conditions content available.
          </p>
        )}
      </div>
    </div>
  );
}

export default TermsConditions;
